import React from "react";

export const WidthContext = React.createContext(0);
export const HeightContext = React.createContext(0);
